import React from "react";

const SafetyHealthEnvironmental = ({ ...props }) => {
    return (
      <div>
        <p>
          Coming soon
        </p>
      </div>
    );
  };
  
  export default SafetyHealthEnvironmental;